import React from "react";
export interface LocationDetailProps {
  property: any;
}
export default function LocationDetail(props: LocationDetailProps) {

  // console.log("props  >>>>>>>" , props)
  return (
    <div className="bg-gray-100 border">
      <div className="max-w-7xl mx-auto">
        <dl className="sm:max-w-7xl sm:mx-auto sm:grid sm:grid-cols-4 auto-rows-max sm:gap-8 divide-x">
          <div className="flex items-start flex-col py-4 px-4 lg:px-0">
            <dt className="order-2 mt-2 text-base text-gray-500 leading-6 capitalize">
              {props.property?.city?.name},{" "}
              <span className="font-semibold">
                {props.property?.state?.name}
              </span>
            </dt>
            <dd className="order-1 text-xl font-semibold">Location</dd>
          </div>
          <div className="flex items-center justify-start lg:justify-center">
            <div className="flex flex-col items-start mt-6 sm:mt-0 py-4 px-4 lg:px-0">
              <dt className="order-2 mt-2 text-base text-gray-500 leading-6 capitalize">
                {props.property?.asset?.name}
              </dt>
              <dd className="order-1 text-xl font-semibold">Type</dd>
            </div>
          </div>
          <div className="flex items-start justify-start lg:justify-center">
            <div className="flex flex-col items-start mt-6 sm:mt-0 py-4 px-4 lg:px-0">
              <dt className="order-2 mt-2 text-base text-gray-500 leading-6 capitalize">
                {props.property?.sub_asset_type?.name}
              </dt>
              <dd className="order-1 text-xl font-semibold">Sub Type</dd>
            </div>
          </div>
          <div className="flex items-start justify-start lg:justify-center">
            <div className="flex flex-col items-start mt-6 sm:mt-0 py-4 px-4 lg:px-0">
              <dt className="order-2 mt-2 text-center sm:text-left text-base text-gray-500 leading-6 capitalize">
                {props.property?.bank?.name}
              </dt>
              <dd className="order-1 text-xl font-semibold">Institution</dd>
            </div>
          </div>
        </dl>
      </div>
    </div>
  );
}
